var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLedgerDetailLoanTimelineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5028 13.7514V11.5005C17.5028 10.8782 16.2423 10.375 14.6892 10.375C13.136 10.375 11.8763 10.8791 11.8755 11.5005V16.0023C11.8763 16.6238 13.1352 17.1278 14.6892 17.1278C16.2431 17.1278 17.502 16.6238 17.5028 16.0023V11.5005",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72119 11.3995L9.46433 9.72701V6.2373",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8294 7.74915C15.0431 4.30483 11.7342 2.04928 8.24077 2.57627C4.74737 3.10325 2.25109 6.23452 2.51582 9.75751C2.78054 13.2805 5.71672 16.0036 9.24965 16.0026",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8765 11.5C11.8765 12.1214 13.1362 12.6255 14.6901 12.6255C16.2441 12.6255 17.503 12.1214 17.503 11.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8765 13.751C11.8765 14.3724 13.1362 14.8764 14.6901 14.8764C16.2441 14.8764 17.5038 14.3724 17.5038 13.751",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedgerDetailLoanTimelineIcon);
export default __webpack_public_path__ + "static/media/ledger-detail-loan-timeline-icon.127e2fabda4fc501fc2ff92636626f0d.svg";
export { ForwardRef as ReactComponent };